import React, { useReducer, useContext } from "react";
import { managerPolicyReducer as reducer } from "../reducers/managerPolicyReducer";
import { managerPolicyActions as actions } from "../actions/managerPolicyActions";

const initialValue = {
  policy: null,
  enterpriseId: null,
};

const managerPolicyContext = React.createContext();

const ManagerPolicyContext = ({ children, enterpriseId }) => {
  initialValue.enterpriseId = enterpriseId;
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <managerPolicyContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </managerPolicyContext.Provider>
  );
};

export const useManagerPolicyContext = () =>
  React.useContext(managerPolicyContext);
export default ManagerPolicyContext;
